<template>
  <div
    class="videos"
    :class="[
      $blockClass(blockClass, 'video-container'),
      { 'images--no-padding': !padding },
    ]"
  >
    <span
      v-if="padding"
      class="video__spacer"
      :class="[
        $blockClass(blockClass, 'spacer'),
        { 'videos__spacer--mobile': ratioDesktop }
      ]"
      :style="{ paddingBottom: getAspectRatio() }"
      aria-hidden="true"
    />

    <span
      v-if="padding && ratioDesktop"
      class="videos__spacer videos__spacer--desktop"
      :class="$blockClass(blockClass, 'spacer')"
      :style="{ paddingBottom: getAspectRatio(true) }"
      aria-hidden="true"
    />
    <video
      :src="videoSrc"
      :class="$blockClass(blockClass, 'video')"
      :data-poster="poster"
      data-autoplay=""
      class="videos__video lazyload"
      loop="true"
      muted="true"
      playsinline="1"
      preload="none"
      type="video/mp4"
    />
  </div>
</template>

<script>

/**
 * Vue: Hero banner video (hero-banner-video)
 * -----------------------------------------------------------------------------
 * A hero banner video component with spacers.
 *
 */
export default {
  name: 'HeroBannerVideo',

  props: {
    videoSrc: {
      type: String,
      default: '',
    },
    blockClass: {
      type: String,
      default: '',
    },
    ratio: {
      type: String,
      default: '',
    },
    ratioDesktop: {
      type: String,
      default: '',
    },
    padding: {
      type: Boolean,
      default: true,
    },
    poster: {
      type: [String, Boolean],
      default: false,
    },
  },

  data() {
    return {

    }
  },

  computed: {

  },

  mounted() {
    // Not empty
  },

  methods: {

    /**
     * Get aspect ratio.
     * @param {Boolean} desktop - Desktop breakpoint?
     * @returns {Number|Null}
     */
    getAspectRatio(desktop) {
      if (!this.padding) {
        return null
      }

      const ratio = desktop ? this.ratioDesktop : this.ratio

      let height = ''
      let width = ''

      /**
       * If ratio is passed as aspect ratio.
       */
      if (ratio && ratio.includes(':')) {
        height = ratio.split(':')[1] * 100.00
        width = ratio.split(':')[0]
      }

      return `${height / width}%`
    },

  },
}
</script>
